export const sanitizeAccessCodeStudentNumber = (accessCode:string | number, studentNumber:string | number) => {
    return {
        accessCode: (''+(accessCode || '')).replace(/[\W_]+/g, ""), // not case sensitive
        studentNumber: (''+(studentNumber || '')).replace(/[\W_]+/g, ""),
    }
} 